import { Component, Input, OnInit } from '@angular/core';
import { IonNav, AlertController } from '@ionic/angular';
import { CaseService } from 'src/app/services/case.service';
import { CommonService } from 'src/app/services/common.service';
import { PaymentFrequencyPage } from '../payment-frequency/payment-frequency.page';
import { PaymentService } from 'src/app/services/payment.service';
import { TranslateService } from '@ngx-translate/core';

@Component({
  selector: 'app-payment-option',
  templateUrl: './payment-option.page.html',
  styleUrls: ['./payment-option.page.scss'],
})
export class PaymentOptionPage implements OnInit {
  @Input() caseData;
  @Input() debtorDetails;
  @Input() planType='plan';
  message = '';
  paymentOption = [
    {
      title: this.translate.instant('CASE_DETAIL.PAY_IN_FULL'),
      label: this.translate.instant('CASE_DETAIL.PAY_IN_FULL'),
      desc: this.translate.instant('CASE_DETAIL.PAY_IN_FULL_DESC'),
      type: 'payFull',
      iconName: 'card-outline',
    },
    {
      title: this.translate.instant('PAYMENT.PAYMENT_PLAN_OPTION.TITLE'),
      label: this.translate.instant('PAYMENT.PAYMENT_PLAN_OPTION.CREATE'),
      desc: this.translate.instant('PAYMENT.PAYMENT_PLAN_OPTION.DESC'),
      type: 'paymentPlan',
      iconName: 'albums-outline',
    },
    {
      title: this.translate.instant('CASE_DETAIL.ONE_TIME_PAYMENT'),
      label: this.translate.instant('CASE_DETAIL.PAY_OTHER_AMOUNT'),
      desc: this.translate.instant('CASE_DETAIL.MAKE_ONE_TIME_PAYMENT'),
      type: 'oneTimePayment',
      iconName: 'time-outline',
    },
  ];

  constructor(
    private caseService: CaseService,
    private commonService: CommonService,
    private ionNav: IonNav,
    private paymentService: PaymentService,
    private alertController: AlertController,
    private translate: TranslateService
  ) {}

  ngOnInit() {
    let portalSettings = JSON.parse(localStorage.getItem('portal_settings'));
    this.message = portalSettings.interest_message;
  }
  openAmountActionSheet(fullAmount) {
    this.paymentService.presentActionSheet(this.caseData, fullAmount);
  }

  handleOptionSelect(type) {
    if (type === 'paymentPlan') {
      this.caseService.setPaymentData({ paymentOption: type });
      this.ionNav.push(PaymentFrequencyPage, {
        caseData: this.caseData,
        planType: this.planType
      });
    } else if (type === 'payFull') {
      this.openAmountActionSheet(true);
    } else if (type === 'oneTimePayment') {
      this.openAmountActionSheet(false);
    }
  }
}
